module.exports = __webpack_public_path__ + "img/svip.b19015a5.png";